// Add a <title> to SVG > G > Path element from the wrapping A (link) Title Attribute so that the a system tooltip is shown
// for each link wrapping a <g>region</g>, we copy its title and paste it into g>path ; so that the "infobulle" at the hover is specific for the region
var fn_svg_title = function() {
    $('#map__image_svg a').each(function() {
        $(this).find('g').find('path').html('<title>' + $(this).attr("title") + '</title>');
    })
}
